/*@flow*/
import scriptjs from 'scriptjs';

function initFilePicker(o: { accepted?: string[] } = {}): Promise<Object> {
  const loadLibrary = new Promise(resolve => {
    // let url = '//static.filestackapi.com/v3/filestack.js';
    let url = '//static.filestackapi.com/filestack-js/1.x.x/filestack.min.js';
    scriptjs(url, 'fjs').ready('fjs', resolve);
  });

  const prepareClient = () => {
    // Recycle the existing client
    let client0 =
      window.client0 || window.filestack.init(window.CONFIG.FILEPICKER_API_KEY);
    window.client0 = client0;

    return {
      ...client0,
      openDialog() {
        return new Promise(resolve => {
          const onUploadDone = res => {
            resolve(res.filesUploaded);
          };

          // TODO: reject onClose

          client0
            .picker({ accept: o.accepted || ['image/*'], onUploadDone })
            .open();
        });
      },
      crop(files) {
        return new Promise(resolve => {
          const onUploadDone = res => {
            resolve(res.filesUploaded);
          };

          // TODO: reject onClose

          client0
            .picker({ accept: o.accepted || ['image/*'], onUploadDone })
            .crop(files);
        });
      },
    };
  };

  return loadLibrary.then(prepareClient);
}

//
// TODO: test
//
export default initFilePicker;
